import {PluginSettings} from './abstract-data-api-plugin';
import {Pagination} from '../components/pagination';
import {AbstractList} from './abstract-list';

/**
 * Base for a paginated list plugin.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractPaginatedList<T extends any, S extends PluginSettings> extends AbstractList<T, S> {
  protected pagination: Pagination;

  constructor(container: HTMLElement) {
    super(container);
    const paginationContainer = container.querySelector<HTMLDivElement>('[data-pagination]');
    if (!paginationContainer) {
      throw new Error('Pagination container missing.');
    }
    this.pagination = new Pagination(paginationContainer);
  }
}
